import { StageWinnerResponse } from '@/components/game/_domain';

class DefaultWinnersElement {
    public name: string = '';
    public jackpotStage: string = '';
    public winners: StageWinnerResponse[] = [];

    constructor(name: string = '', jackpotStage: string = '', winners: StageWinnerResponse[] = []) {
        this.name = name;
        this.jackpotStage = jackpotStage;
        this.winners = winners;
    }
}

class DefaultStageElement {
    public name: string = '';
    public stage: number;

    constructor( name: string = '', stage: number) {
        this.name = name;
        this.stage = stage;
    }
}

export { DefaultWinnersElement, DefaultStageElement };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/_default/_domain/models/winners-element.ts